import { styled } from '@mui/material/styles';

export const StyledUnorderedList = styled('ul')({
  padding: 0,
  margin: 0,
});
